import React, { useContext, useState } from 'react';
import Image from 'next/legacy/image';

import iconClose from '../public/images/close.svg';
import { SavedSearchesContext } from './SavedHouses/SavedSearchContext';
import { Dialog } from '@mui/material';

type PopUpDeleteSearchProps = {
  searchId?: number;
  searchName: string;
};
const PopUpDeleteSearch: React.FC<PopUpDeleteSearchProps> = ({
  searchId,
  searchName,
}) => {
  const [open, setOpen] = useState(false);

  const { deleteSearch } = useContext(SavedSearchesContext);

  const deleteSavedSearches = async () => {
    deleteSearch(searchId).then(() => setOpen(false));
  };

  return (
    <>
      <button onClick={() => setOpen(true)}>
        <div className="items-center cursor-pointer">
          <div className="flex items-center justify-between h-8 px-2 mt-1 uppercase bg-white text-red xl:mt-0">
            {searchId ? 'Delete search' : 'Clear all'}
          </div>
        </div>
      </button>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md">
        <div className="p-10 bg-white">
          <div className="flex flex-row items-start justify-between mb-8 md:w-145">
            <div className="relative flex flex-col justify-center text-24-32-0.3 md:text-28-38-0.3 w-max font-sohneKraftig">
              {searchName}
            </div>
            <button
              className="absolute outline-none right-10 md:right-0 top-6 md:top-0 md:relative md:pt-[9px] lg:pt-[10px]"
              onClick={() => setOpen(false)}
            >
              <Image src={iconClose} alt="close popup" width={15} height={15} />
            </button>
          </div>
          <div>
            Are you sure you want to delete{' '}
            {searchId ? 'this search' : 'all your searches'}?
          </div>
          <div className="flex justify-between mt-8 text-12-18-0.3 md:w-3/5 md:text-16-26-0.3">
            <button
              onClick={() => setOpen(false)}
              className="w-32 h-10 uppercase bg-white border md:h-12 md:w-40 border-gold"
            >
              Cancel
            </button>
            <button
              onClick={() => deleteSavedSearches()}
              className="w-32 h-10 uppercase border md:h-12 md:w-40 bg-red-light border-red-light"
            >
              Delete
            </button>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default PopUpDeleteSearch;
